<template>
  <v-container id="pedidosform" tag="section">
    <base-v-component :heading="verPedido" />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-card-text>
        <v-container grid-list-md>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="pedido.fechaMostrar"
                readonly
                label="Fecha"
                rounded
                outlined
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="pedido.restaurante"
                readonly
                label="Restaurante"
                rounded
                outlined
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="pedido.negocio"
                readonly
                label="Negocio"
                rounded
                outlined
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="pedido.forma_pago"
                readonly
                label="Forma de pago"
                rounded
                outlined
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="pedido.canalVenta"
                readonly
                label="Canal Venta"
                rounded
                outlined
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="pedido.numPedidoRest"
                readonly
                label="Pedido del restaurante"
                rounded
                outlined
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="pedido.numPedidoRestDia"
                readonly
                label="Pedido del día"
                rounded
                outlined
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="pedido.modo"
                readonly
                label="Modo"
                rounded
                outlined
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              v-if="pedido.payment_intent && role == 'admin'"
            >
              <v-text-field
                v-model="pedido.payment_intent"
                readonly
                label="Payment intent"
                rounded
                outlined
              />
            </v-col>
          </v-row>
          <v-row v-if="pedido.modo == 'domicilio'">
            <v-col cols="12"><h2>Dirección</h2></v-col>
            <v-col cols="12">
              <v-textarea
                v-model="direccionMostrar"
                readonly
                label="Dirección"
                rounded
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
        <!-- CARRITO -->
        <v-container class="pa-0 px-10">
          <v-row>
            <v-col cols="12" lg="6">
              <h3 class="text-center text-h3">Productos</h3>
              <v-row
                class="py-3 borderBottom"
                justify="center"
                no-gutters
                v-for="(prod, i) in pedido.productos"
                :key="i"
              >
                <v-col class="pa-0 ma-0" cols="2" style="max-width: 54px">
                  <v-select
                    style="margin-top: 4px !important"
                    hide-details
                    class="pa-0 ma-0 font-weight-medium"
                    :items="cantidadSelect(prod.cantidad)"
                    disabled
                    v-model="prod.cantidad"
                    :key="prod.nombre"
                    item-text="text"
                    item-value="val"
                    :menu-props="{ maxHeight: 'auto' }"
                  >
                    <template slot="append">
                      <v-icon class="subtitle-1 lighten-4--text mt-1"
                        >mdi-chevron-down</v-icon
                      >
                    </template>
                  </v-select>
                  <!-- <v-list-item-title class="mt-2 font-weight-medium" v-else>
            {{ prod.cantidad.toString() }}
            <span class="grey--text font-weight-regular">x</span> 
          </v-list-item-title>-->
                </v-col>
                <v-col cols class="pl-4 py-2 text-truncate">
                  <v-list-item-title class="font-weight-medium">{{
                    !!prod.nombreEs ? prod.nombreEs : prod.nombre
                  }}</v-list-item-title>
                  <v-list-item-subtitle
                    class
                    v-for="(opcion, i) in prodOpcionesNameComputado(
                      !!prod.opcionesNombreEs
                        ? prod.opcionesNombreEs
                        : prod.opcionesName
                    )"
                    :key="i"
                    >{{ opcion.cantidad > 1 ? opcion.cantidad + 'x' : '--' }}
                    {{ opcion.key }}</v-list-item-subtitle
                  >
                </v-col>
                <v-col cols class style="max-width: 76px">
                  <v-list-item-title
                    class="text-end py-2 font-weight-medium text-right"
                    >{{
                      replaceComa(
                        (
                          prod.cantidad *
                          (sumaOpciones(prod.opcionesPrecio) +
                            parseFloat(prod.precio))
                        ).toFixed(2)
                      )
                    }}
                    €</v-list-item-title
                  >
                </v-col>
              </v-row>
              <v-row
                v-if="
                  pedido.modo == 'domicilio' &&
                  pedido.recargo &&
                  pedido.recargo > 0 &&
                  pedido.precioTotal > 0
                "
              >
                <v-col cols class="pl-4 py-2 text-truncate">
                  <v-list-item-title class="font-weight-medium"
                    >Recargo</v-list-item-title
                  >
                  <v-list-item-subtitle class
                    >Por servicio a domicilio</v-list-item-subtitle
                  >
                </v-col>
                <v-col cols class style="max-width: 76px">
                  <v-list-item-title class="text-end py-2 font-weight-medium"
                    >{{
                      replaceComa(pedido.recargo.toFixed(2))
                    }}
                    €</v-list-item-title
                  >
                </v-col>
              </v-row>

              <v-list class="h-100" color="transparent">
                <!-- Total y Subtotal -->
                <!--<v-list-item class="ma-0 pa-0">
        <v-row class no-gutters>
          <v-col offset="0" cols="12" class="mb-4 mt-2">
            <v-text-field hide-details outlined label="Código de descuento"></v-text-field>
          </v-col>
        </v-row>
      </v-list-item>-->
                <v-divider></v-divider>
                <v-list-item class="ma-0 pa-0">
                  <v-row no-gutters class="grey--text">
                    <v-col cols="6">Subtotal</v-col>
                    <v-col
                      class="nowrap_space d-flex justify-end ma-0 grey--text"
                      cols="6"
                      >{{
                        calculoPrecioTotal != undefined
                          ? (
                              calculoPrecioTotal - calculoImpuestosCarrito
                            ).toFixed(2)
                          : '0.00'
                      }}
                      €</v-col
                    >
                  </v-row>
                </v-list-item>
                <v-list-item class="ma-0 pa-0">
                  <v-row no-gutters class="grey--text">
                    <v-col cols="6" class="pa-0 ma-0">{{
                      getImpuestoTexto
                    }}</v-col>
                    <v-col
                      class="nowrap_space d-flex justify-end ma-0 grey--text pa-0 ma-0"
                      cols="6"
                      >{{
                        calculoPrecioTotal != undefined
                          ? calculoImpuestosCarrito.toFixed(2)
                          : '0.00'
                      }}
                      €</v-col
                    >
                  </v-row>
                </v-list-item>

                <v-list-item class="headline pa-0 ma-0">
                  <v-row no-gutters class="headline pb-4">
                    <v-col cols="6">Total</v-col>
                    <v-col
                      class="nowrap_space d-flex justify-end ma-0 headline"
                      cols="6"
                      >{{
                        calculoPrecioTotal != undefined
                          ? calculoPrecioTotal.toFixed(2)
                          : '0.00'
                      }}
                      €</v-col
                    >
                  </v-row>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" lg="6">
              <h3 class="text-center text-h3">Cobrado desglose</h3>
              <v-expansion-panels v-model="expansionPanelCobradoDeglose">
                <v-expansion-panel
                  v-for="(p, i) in cobradoDesglose"
                  :key="'cobrado_' + i"
                >
                  <v-expansion-panel-header>
                    <v-card-title class="mb-0 pb-0">
                      {{ p.formaPagoNombre }}
                      <v-spacer></v-spacer>
                      <span class="font-weight-bold">{{
                        p.pagadoMostrar
                      }}</span>
                      <v-list-item-subtitle v-if="!!p.entregado"
                        >Entregado: {{ p.entregado }} | Cambio:
                        {{ p.cambio }}</v-list-item-subtitle
                      >
                    </v-card-title>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card
                      elevation="0"
                      rounded="lg"
                      class="py-0 overflow-hidden"
                      v-if="role == 'admin'"
                    >
                      <v-card-actions class="pt-2">
                        <v-row dense>
                          <v-alert
                            v-if="!!p.abonoContablePor"
                            outlined
                            width="100%"
                            type="warning"
                            prominent
                            dense
                            border="left"
                            class="mb-0 font-weight-bold"
                            style="background-color: white !important"
                          >
                            Abono del pago:
                            {{ p.abonoContablePor }}
                          </v-alert>
                          <v-alert
                            v-if="!!p.esAbono"
                            outlined
                            width="100%"
                            type="warning"
                            prominent
                            dense
                            border="left"
                            class="mb-0 font-weight-bold"
                            style="background-color: white !important"
                          >
                            Abona el pago:
                            {{ p.abonoCodigoFactura }}
                          </v-alert>
                          <v-col cols="12">
                            Factura: {{ p.codigoFactura }}
                          </v-col>

                          <v-col cols="6">
                            <v-btn
                              @click="abrirFacturaCliente(p)"
                              block
                              color="primary"
                              outlined
                              class="body-2 font-weight-bold rounded-lg my-3"
                              rounded
                            >
                              <v-icon small class="mr-2"
                                >mdi-file-pdf-box</v-icon
                              >{{ p.ficheroFactura ? 'VER FACT' : 'FACTURAR' }}
                            </v-btn>
                          </v-col>
                          {{ p.ficheroFactura }}
                          <v-col cols="6">
                            <v-btn
                              outlined
                              rounded
                              :disabled="!!p.abonoContablePor || !!p.esAbono"
                              @click="
                                crearAbono(pedidoViendo.cobradoDesglose[i], i)
                              "
                              block
                              color="orange darken-1"
                              class="body-2 font-weight-bold black--text rounded-lg my-3"
                            >
                              <v-icon small class="mr-2"
                                >mdi-currency-eur-off</v-icon
                              >
                              ABONO
                            </v-btn>
                          </v-col>
                          <v-col cols="6">
                            <v-btn
                              v-if="!p.codigoFactura && false"
                              @click="contabilizar(p)"
                              block
                              outlined
                              color="light-blue darken-1"
                              class="body-2 font-weight-bold white--text rounded-lg my-3"
                            >
                              <v-icon small class="mr-2">mdi-check</v-icon>
                              Contabilizar bien
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-actions>
                      <v-list
                        color="green lighten-5"
                        class="mb-2 mx-2 py-0"
                        elevation="2"
                        v-if="!!p.productos"
                      >
                        <template v-for="(prod, j) in p.productos">
                          <v-divider
                            :key="'cobrado_' + i + '_' + j"
                            v-if="j > 0"
                          ></v-divider>
                          <v-list-item
                            :key="prod.id + i + '_' + j"
                            style="height: 60px"
                          >
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold">
                                {{ prod.nombre }}
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action class="text-right my-1">
                              <v-list-item-action-text
                                class="subtitle-1 font-weight-black black--text"
                                >{{
                                  mostrarMoneda(
                                    prod.precioProductoTotalUnitario *
                                      prod.cantidad
                                  )
                                }}€</v-list-item-action-text
                              >
                              <v-chip
                                v-if="prod.cantidad !== 1"
                                small
                                color="primary"
                                class="black--text border"
                                >x{{ prod.cantidad }}</v-chip
                              >
                            </v-list-item-action>
                          </v-list-item>
                        </template>
                      </v-list>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
            <v-col cols="12" lg="6">
              <h3 class="text-center text-h3">
                Usuario

                <v-btn
                  v-if="role == 'admin'"
                  small
                  text
                  color="success"
                  @click="$router.push('/admin/usuario/' + usuario.id)"
                >
                  <v-icon>mdi-account</v-icon></v-btn
                >
              </h3>

              <v-row v-if="usuario">
                <v-col cols="12" lg="6" v-if="role == 'admin'">
                  <v-text-field
                    v-model="usuario.id"
                    readonly
                    label="UID"
                    rounded
                    outlined
                  />
                </v-col>
                <v-col cols="12" lg="6">
                  <v-text-field
                    v-model="usuario.displayName"
                    readonly
                    label="Nombre"
                    rounded
                    outlined
                  />
                </v-col>
                <v-col cols="12" lg="6">
                  <v-text-field
                    v-model="usuario.phoneNumber"
                    readonly
                    label="Teléfono"
                    rounded
                    outlined
                  />
                </v-col>
                <v-col cols="12" lg="6">
                  <v-text-field
                    v-model="usuario.email"
                    readonly
                    label="Email"
                    rounded
                    outlined
                  />
                </v-col>
                <v-col cols="12" lg="6" v-if="role == 'admin'">
                  <v-text-field
                    v-if="role == 'admin'"
                    readonly
                    label="Rol"
                    rounded
                    outlined
                  />
                </v-col>
                <v-col cols="12" lg="6" v-if="role == 'admin'">
                  <v-text-field
                    v-model="usuario.canalRegistro"
                    readonly
                    label="Canal Registro"
                    rounded
                    outlined
                  />
                </v-col>
                <v-col cols="12" lg="6" v-if="role == 'admin'">
                  <v-text-field
                    v-model="usuarioFechaRegistro"
                    readonly
                    label="Fecha Registro"
                    rounded
                    outlined
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions v-if="false">
        <v-btn
          color="primary"
          outlined
          rounded
          :disabled="!pedido.facturaCliente"
          @click="verFactura"
          >Factura</v-btn
        >

        <v-spacer></v-spacer>
      </v-card-actions>
    </base-material-card>
    <v-dialog
      v-model="facturacionDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      overlay-opacity="0.90"
      max-width="600"
      scrollable
      :content-class="
        $vuetify.breakpoint.mdAndUp
          ? 'mt-n4 dialogo--custom-fs elevation-0'
          : 'dialogo--custom-fs'
      "
    >
      <v-card
        class="transparent"
        :class="$vuetify.breakpoint.mdAndUp ? '' : 'rounded-0'"
      >
        <v-card-title
          v-if="$vuetify.breakpoint.mdAndUp"
          class="py-6 transparent"
        >
          <!-- <v-btn
            color="primary"
            @click="facturacionDialog = false"
            right
            absolute
            ><v-icon color="white">mdi-close</v-icon></v-btn
          > -->
        </v-card-title>
        <v-card-title
          :class="
            $vuetify.breakpoint.smAndDown
              ? 'caption'
              : $vuetify.breakpoint.mdAndDown
              ? 'title'
              : 'display-1'
          "
          class="text--primary rounded-t-lg blue-grey lighten-5"
        >
          <!-- <v-icon color="info" class="mr-4"> mdi-currency-eur </v-icon> -->
          <div>
            <span class="font-weight-bold">
              FACTURA - {{ facturarContable.codigoFactura }}
            </span>
          </div>
          <v-btn
            v-if="$vuetify.breakpoint.smAndDown"
            fab
            height="48"
            width="48"
            color="primary"
            @click="facturacionDialog = false"
            absolute
            right
            class="mr-n2 mt-n1"
            ><v-icon size="36" color="black">mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <!-- <v-card-text
        class="pt-4 blue-grey lighten-5"
        :class="
          pedido.fechaMostrar || pedido.copyUsuarioTpv
            ? 'rounded-0'
            : 'rounded-b-lg'
        "
      >
      </v-card-text> -->
        <v-card-title class="blue-grey lighten-5"
          >Datos de facturación</v-card-title
        >
        <v-card-text class="blue-grey lighten-5" v-if="editarCliente">
          <v-row class="my-0">
            <v-col cols="12">
              <v-checkbox
                label="Actualizar datos del cliente y pedido"
                v-model="actualizarDatosCliente"
              />
            </v-col>
            <v-col cols="12">
              <v-alert
                v-if="actualizarDatosCliente"
                type="warning"
                dense
                colored-border
                border="left"
                class="mb-0 rounded-lg"
                icon="mdi-alert"
                >Al cambiar los datos de facturación se guardarán en el
                cliente</v-alert
              ></v-col
            >
            <v-col cols="12">
              <v-text-field
                label="Razón Social / Nombre Completo"
                v-model="editarCliente.facturacionRazonSocial"
                ref="facturacionRazonSocial"
              />
              {{ editarCliente.facturacionRazonSocial }}
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="CIF / NIF"
                v-model="editarCliente.facturacionNifCif"
                ref="facturacionNifCif"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Código Postal"
                v-model="editarCliente.facturacionCp"
                ref="facturacionCp"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Direccion"
                v-model="editarCliente.facturacionDireccion"
                ref="facturacionDireccion"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Municipio"
                v-model="editarCliente.facturacionMunicipio"
                ref="facturacionMunicipio"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Provincia"
                v-model="editarCliente.facturacionProvincia"
                ref="facturacionProvincia"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="blue-grey lighten-5 py-4 justify-end">
          <v-btn
            :loading="generarFacturaLoading"
            @click="generarFactura"
            color="primary"
            class="black--text rounded-lg"
            large
            >GENERAR FACTURA</v-btn
          >
        </v-card-actions>
        <template v-if="pedido.fechaMostrar || pedido.copyUsuarioTpv">
          <v-divider></v-divider>
          <v-card-actions
            class="py-3 blue-grey lighten-5"
            :class="$vuetify.breakpoint.mdAndUp ? 'rounded-b-lg' : 'rounded-0'"
          >
            <v-row>
              <v-col
                v-if="pedido.fechaMostrar"
                cols="12"
                sm="6"
                class="pb-0 pb-sm-3"
              >
                <v-icon size="18" class="mr-2 mt-n1"> mdi-clock-outline </v-icon
                >Registrado a las
                <span class="font-weight-bold">
                  &nbsp;{{ pedido.fechaMostrar }}
                </span>
              </v-col>
              <v-col
                v-if="pedido.copyUsuarioTpv && pedido.copyUsuarioTpv.nombre"
                cols="12"
                sm="6"
                :offset-sm="!pedido.fechaMostrar ? 6 : 0"
                class="text-sm-right pt-0 pt-sm-3"
              >
                <v-icon
                  v-if="$vuetify.breakpoint.xsOnly"
                  size="18"
                  class="mr-2 mt-n1"
                >
                  mdi-account-box </v-icon
                >Atendido por
                <span class="font-weight-bold">
                  &nbsp;{{ pedido.copyUsuarioTpv.nombre }}
                </span>
              </v-col>
            </v-row>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import moment from 'moment';
  import { mostrarMoneda } from '@/utils/utils.js';

  export default {
    data() {
      return {
        facturarContable: {},
        actualizarDatosCliente: true,
        generarFacturaLoading: false,
        editarCliente: {},
        facturacionDialog: false,
        expansionPanelCobradoDeglose: 0,
        cantidadProducto: [
          { val: 0, text: 'Eliminar' },
          { val: 1, text: '1x' },
          { val: 2, text: '2x' },
          { val: 3, text: '3x' },
          { val: 4, text: '4x' },
          { val: 5, text: '5x' },
          { val: 6, text: '6x' },
          { val: 7, text: '7x' },
          { val: 8, text: '8x' },
          { val: 9, text: '9x' },
          { val: 10, text: '10x' },
        ],
        usuario: {
          id: '',
          email: '',
          phoneNumber: '',
          displayName: '',
          restaurantes: [],
          negocios: [],
          role: [],
          canalRegistro: '',
          fecha: null,
        },
        pedido: {
          id: null,
          fechaMostrar: '',
          fechaServidor: null,
          canalVenta: '',
          negocio: '',
          restaurante: '',
          numPedidoRestDia: null,
          numPedidoRest: null,
          modo: '',
          direccion: '',
          productos: [],
        },
      };
    },
    watch: {
      facturacionDialog(v) {
        if (!v) {
          this.facturarContable = {};
          this.generarFacturaLoading = false;
        } else {
          this.editarCliente = {
            //inicializamos valores si no los tiene
            facturacionRazonSocial: '',
            facturacionNifCif: '',
            facturacionCp: '',
            facturacionDireccion: '',
            facturacionProvincia: '',
            facturacionMunicipio: '',
            ...(this.pedido && this.pedido.copyUser
              ? this.pedido.copyUser
              : {}),
          };
        }
      },
    },
    computed: {
      cobradoDesglose() {
        return this.pedido.cobradoDesglose
          ? this.pedido.cobradoDesglose.map((c) => {
              let fForma =
                this.$store.state.estadisticas.filtros.formaPago.find(
                  (f) => f.value == c.formaPago
                );
              if (fForma) {
                return {
                  ...c,
                  formaPagoNombre: fForma.text,
                  pagadoMostrar: mostrarMoneda(c.pagado),
                  productos: !!c.productos ? c.productos : [],
                  codigoFactura: !!c.codigoFactura ? c.codigoFactura : '',
                  entregado:
                    fForma.value == 'efectivo'
                      ? mostrarMoneda(c.entregado)
                      : false,
                  cambio:
                    fForma.value == 'efectivo'
                      ? mostrarMoneda(c.cambio)
                      : false,
                };
              } else {
                return {
                  ...c,
                  formaPagoNombre: c.formaPago,
                  pagadoMostrar: mostrarMoneda(c.pagado),
                };
              }
            })
          : [];
      },
      ...mapGetters({
        //   pedidosBruto: "pedidos/getPedidosListado",
        role: 'auth/role',
      }),
      usuarioFechaRegistro() {
        return this.usuario.fecha
          ? moment.unix(this.usuario.fecha.seconds).format('DD-MM-YYYY HH:mm')
          : '';
      },
      direccionMostrar() {
        return this.pedido.direccion
          ? this.pedido.direccion.calle +
              ', ' +
              this.pedido.direccion.numero +
              ', ' +
              this.pedido.direccion.adicional +
              '\n' +
              this.pedido.direccion.cp +
              ', ' +
              this.pedido.direccion.municipio +
              ', ' +
              this.pedido.direccion.provincia
          : '';
      },
      verPedido() {
        return 'Ver pedido ' + this.pedido.id;
      },
      ...mapState({
        idiomas: 'idiomas',
        langDefecto: 'langDefecto',
      }),
      langSeleccionado: {
        get() {
          return this.$store.state.langSeleccionado;
        },
        set(v) {
          this.$store.commit('setLangSeleccionado', v);
        },
      },
      calculoImpuestosCarrito() {
        let precio = 0;
        this.pedido.productos.forEach((e) => {
          let impuesto = e.impuesto;
          let opciones = e.opcionesPrecio;
          let precioOpciones = 0;

          if (opciones.length > 0) {
            const reducer = (accumulator, currentValue) =>
              accumulator + currentValue;
            precioOpciones = opciones.reduce(reducer);
          }
          let precioProducto =
            (parseFloat(e.precio) + precioOpciones) * e.cantidad;
          let base = precioProducto / (1 + parseFloat(impuesto));
          precio += precioProducto - base;
        });
        return precio;
      },
      calculoPrecioTotal() {
        return this.pedido.precioTotal;
      },
      getImpuestoTexto() {
        const impuestos = this.$store.state.impuestos.impuestosArray;

        let restObjFound = this.$store.state.app.restaurantesArray.find(
          (r) => r.id == this.pedido.negocio + '-' + this.pedido.restaurante
        );
        if (restObjFound) {
          var found = impuestos.find((i) => i.id == restObjFound.impuesto);
          if (found) {
            return found.nombre.replace(/ .*/, '');
          } else {
            return '';
          }
        }
      },
    },
    methods: {
      generarFactura() {
        console.log(this.facturarContable);
        console.log(this.pedido);
        console.log(this.editarCliente);
        // return;
        this.generarFacturaLoading = true;

        var promesa = this.actualizarDatosCliente
          ? this.$store
              .dispatch('clientes/saveCliente', this.editarCliente)
              .then(() =>
                this.$store.dispatch('pedidos/savePedido', {
                  id: this.pedidoEditandoObj.id,
                  copyUser: {
                    ...this.pedidoEditandoObj.copyUser,
                    ...this.editarCliente,
                  },
                })
              )
          : Promise.resolve();

        promesa
          .then((r) =>
            this.$store.dispatch('contabilidad/generarFactura', {
              pedido: this.pedido,
              pago: this.facturarContable,
              copyUser: this.editarCliente,
            })
          )
          .then(() => {
            this.facturacionDialog = false;
          })
          .finally(() => {
            this.generarFacturaLoading = false;
          });
        return;
      },
      abrirFacturaCliente(c) {
        if (c.ficheroFactura) {
          this.abrirFactura(c.ficheroFactura);
        } else if (this.pedido.uid == '0') {
          this.$store.commit('setAbrirInfoCliente', true);
        } else {
          // this.$store.commit("pedidos/setFacturacionContableFacturar", c);
          // this.$store.commit("pedidos/setFacturacionDialog", true);
          this.facturacionDialog = true;
          this.facturarContable = c;
        }
      },
      mostrarMoneda(s) {
        return mostrarMoneda(s);
      },
      contabilizar(p) {
        console.log(p);
        this.$store
          .dispatch('contabilidad/contabilizarPedidoAntiguo', this.pedido)
          .then(() => {
            this.getPedido();
          });
      },
      verFactura() {
        window.open(this.pedido.facturaCliente, '_blank');
      },
      convertTree(objs) {
        const obj = JSON.parse(JSON.stringify(objs));
        var item = [];
        var iterar;
        if (typeof obj === 'object') {
          iterar = Object.entries(this.pedidoObj);
        } else if (Array.isArray(obj)) {
          iterar = obj.reduce(function (o, val) {
            o[val] = val;
            return o;
          }, {});
        }
        iterar.forEach(([key, value]) => {
          //console.log(key + " " + value);
          if (typeof value === 'object') {
            var that = this;
            setTimeout(function () {
              const c = 'hijos'; //that.convertTree(value);
              item.push({
                id: key,
                name: key,
                children: c,
              });
            }, 500);
          } else {
            item.push({
              id: key,
              name: key + ': ' + value,
            });
          }
        });
        return item;
      },
      goListado() {
        let str = '/admin/pedidos/';
        this.$router.push(str);
      },
      cantidadSelect(num) {
        let res = this.cantidadProducto;
        let temp = [{ val: num.toString(), text: num.toString() + 'x' }];
        if (num > res.length - 1) {
          return res.concat(temp);
        } else {
          return res;
        }
      },
      prodOpcionesNameComputado(opcionesName) {
        var res = [];
        opcionesName.forEach((op) => {
          var index = res.findIndex((o) => o.key == op);
          if (index < 0) {
            res.push({
              key: op,
              cantidad: 1,
            });
          } else {
            res[index].cantidad++;
          }
        });
        return res;
      },
      breadcrumbOpciones(opciones) {
        let bread = '';
        opciones.forEach(function (e, i) {
          bread += e;
          i != opciones.length - 1 ? (bread += ' / ') : '';
        });
        return bread;
      },
      replaceComa(str) {
        return str.toString().trim().replace('.', ',');
      },
      sumaOpciones(array) {
        if (array.length > 0) {
          const reducer = (accumulator, currentValue) =>
            accumulator + currentValue;
          return array.reduce(reducer);
        } else {
          return 0;
        }
      },
      getPedido() {
        var _vm = this;

        if (this.id) {
          this.$store
            .dispatch('pedidos/getPedido', this.id)
            .then((r) => {
              _vm.pedido = r;
              console.log(r);
              _vm.pedido.fechaMostrar = moment(r.fechaServidor.toDate()).format(
                'HH:mm YYYY-MM-DD'
              );
              if (this.role == 'admin') {
                return this.$store.dispatch('users/getUsuario', r.uid);
              } else {
                return r.copyUser;
              }
            })
            .then((user) => {
              console.log(user);
              _vm.usuario = user;
            })
            .catch((e) => {
              _vm.$store.commit('snackbar/setMensajeDanger', {
                msj: e,
              });
              _vm.goListado();
            });
        } else {
          this.goListado();
        }
      },
    },
    created() {},
    mounted() {
      this.id = this.$route.params.id;
      this.getPedido();
    },
  };
</script>

<style></style>
